import React from "react";
import "./HeaderCadastro.css";
import Icon from "../../core/components/Icon.tsx";
import Separator from "../../core/components/Separator.tsx";

function HeaderCadastro({ texto }) {
	return (
		<div className="cadastro-embarque">
			<p
				style={{
					marginLeft: "5px",
				}}
				className="texto-cadastro-embarque"
			>
				{texto}
			</p>
			<Icon name="Info" size="lg" theme="dark" />
		</div>
	);
}

export default HeaderCadastro;
